(ns nl.mediquest.lib.subs
  (:require
   [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::system
 (comp :system
       :nl.mediquest.lib/db))
